import { render, staticRenderFns } from "./Nomenclatures.vue?vue&type=template&id=16d26be4"
import script from "./Nomenclatures.vue?vue&type=script&lang=js"
export * from "./Nomenclatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports